import { ButtonGroup } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as React from 'react';

interface StyledToggleProps {
  value: boolean | null,
  onChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, value: boolean) => void,
  loading?: boolean,
}

export const StyledToggle = ({value, onChange, loading}: StyledToggleProps) => {

  return <ButtonGroup>
    <LoadingButton onClick={e => onChange(e, true)}
                   loading={loading} sx={{minHeight: 20, borderRadius: '4px', fontSize: 12}}
                   size={'small'}
                   variant={value ? 'contained' : 'outlined'}
                   color={value !== null ? 'success' : 'primary'}>
      Yes
    </LoadingButton>

    <LoadingButton onClick={e => onChange(e, false)}
                   loading={loading} sx={{minHeight: 20, borderRadius: '4px', fontSize: 12}}
                   size={'small'}
                   variant={value === false ? 'contained' : 'outlined'}
                   color={value !== null ? 'error' : 'primary'}>
      No
    </LoadingButton>
  </ButtonGroup>
}
